import React, { useState } from "react";
import {
 Button,
 CircularProgress,
 Box,
 Typography,
 Alert,
} from "@mui/material";
import AWS from "aws-sdk";

const useFileUpload = () => {
 const [isUploading, setIsUploading] = useState(false);
 const [error, setError] = useState(null);
 const [uploadedFileUrl, setUploadedFileUrl] = useState("");

 const uploadFile = async (file) => {
  setIsUploading(true);
  setError(null);

  const S3 = new AWS.S3({
   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
   secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
   region: process.env.REACT_APP_AWS_REGION,
  });

  const params = {
   Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
   Key: `${Date.now()}-${file.name}`, // unique file name
   Body: file,
   ContentType: file.type,
   ACL: "public-read", // adjust as per your requirement
  };

  try {
   const uploadResult = await S3.upload(params).promise();
   setUploadedFileUrl(uploadResult.Location);
  } catch (err) {
   setError(err.message);
  } finally {
   setIsUploading(false);
  }
 };

 return { uploadFile, isUploading, error, uploadedFileUrl };
};

const AdminProfile = () => {
 const { uploadFile, isUploading, error, uploadedFileUrl } = useFileUpload();

 const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
   uploadFile(file);
  }
 };

 return (
  <Box
   sx={{
    maxWidth: 600,
    margin: "auto",
    padding: "30px",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
   }}
  >
   <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
    Convert your picture to URL
   </Typography>

   <Box sx={{ marginBottom: "20px" }}>
    <Typography
     variant="body1"
     color="textSecondary"
     sx={{ marginBottom: "10px" }}
    >
     Upload your picture to s3 and get URL.
    </Typography>
    <input
     type="file"
     onChange={handleFileChange}
     accept="image/*"
     style={{ display: "none" }}
     id="upload-file"
    />
    <label htmlFor="upload-file">
     <Button
      variant="contained"
      component="span"
      sx={{
       backgroundColor: "#6200ea",
       color: "#fff",
       borderRadius: "30px",
       padding: "12px 20px",
       textTransform: "none",
       "&:hover": {
        backgroundColor: "#3700b3",
       },
      }}
     >
      Choose File
     </Button>
    </label>
   </Box>

   {/* Upload Progress and Feedback */}
   {isUploading && (
    <Box sx={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
     <CircularProgress size={24} sx={{ marginRight: "10px" }} />
     <Typography variant="body2" color="textSecondary">
      Uploading...
     </Typography>
    </Box>
   )}

   {error && (
    <Alert severity="error" sx={{ marginBottom: "15px" }}>
     {error}
    </Alert>
   )}

   {uploadedFileUrl && (
    <Alert severity="success" sx={{ marginBottom: "15px" }}>
     File uploaded successfully!{" "}
     <a
      href={uploadedFileUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#6200ea", textDecoration: "underline" }}
     >
      View the file
     </a>
    </Alert>
   )}
  </Box>
 );
};

export default AdminProfile;
